export default "__VITE_ASSET__ffd86b39__"